import * as PropTypes from 'prop-types';
export var GUTTER = 16;
export var MOBILE_VERTICAL_SPACE = 8; // Zeplin vertical spacing link:
// https://app.zeplin.io/project/5a04e5b2e5f0b90b17771a32/screen/5b910928f025929cc78639e0

export var VERTICAL_SPACING = {
  extraSpacious: {
    large: 48,
    small: 32
  },
  spacious: {
    large: 32,
    small: 24
  },
  default: {
    large: 24,
    small: 16
  },
  compact: {
    large: 16,
    small: 12
  }
};
export var unit = function unit(_unit) {
  return "".concat(_unit, "px");
}; // Zeplin card spacing link: Design: zpl.io/25rnAko

export var CARD_PADDING = {
  default: {
    horizontal: 16,
    vertical: {
      smallHeading: 24,
      largeHeading: 32
    }
  },
  SM: {
    horizontal: 32,
    vertical: {
      smallHeading: 24,
      largeHeading: 32
    }
  },
  LG: {
    horizontal: 32,
    vertical: {
      smallHeading: 32,
      largeHeading: 48
    }
  }
};
export var BreakpointPropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['SM', 'MD', 'LG', 'XL'])]);
export var LayoutSizePropType = PropTypes.oneOf(['compact', 'default', 'spacious', 'extraSpacious']);